// UserReports.jsx

import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  TablePagination,
} from "@mui/material";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./UserReports.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

export default function UserReports() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("all");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);



  const token = localStorage.getItem("accessToken");

  // 🔹 Fetch Users


  const role = localStorage.getItem("role");
const userId = localStorage.getItem("userId");


// 🔹 Fetch Users
useEffect(() => {
  const fetchUsers = async () => {
    setLoading(true);

    try {
      let userData = [];

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      };

      // ✅ SUPERVISOR → ONLY THEIR ENGINEERS
      if (role === "S") {

        const response = await axios.get(
          `${API_URL}/api/supervisor_engineers/${userId}/`,
          config
        );

        userData = (response.data.engineers || []).map((eng) => ({
          id: eng.id,
          firstName: eng.first_name,
          lastName: eng.last_name,
          email: eng.email,
          phone: eng.phone_no,
          role: "Site Engineer",
          created_at: eng.created_at || "-",
        }));

        // Only one role for supervisor
        setRoles(["site engineer"]);

        // Remove ALL selection
        setSelectedRole("site engineer");
      }

      // ✅ SUPER ADMIN / CUSTOMER
      else {

        const response = await axios({
          url: `${API_URL}/api/get_all_users/`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        });

        userData = response.data.users || [];

        // 🔹 Extract Unique Roles
        const uniqueRoles = [
          ...new Set(userData.map((u) => u.role?.toLowerCase())),
        ];

        setRoles(uniqueRoles);

        setSelectedRole("all");
      }

      setUsers(userData);
      setFilteredUsers(userData);

    } catch (error) {
      console.error("Error fetching users:", error);
    }

    setLoading(false);
  };

  fetchUsers();

}, [token, role, userId]);


  // useEffect(() => {
  //   const fetchUsers = async () => {
  //     setLoading(true);

  //     try {
  //       const response = await axios({
  //         url: `${API_URL}/api/get_all_users/`,
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         data: {},
  //       });

  //       const userData = response.data.users || [];

  //       setUsers(userData);
  //       setFilteredUsers(userData);

  //       // 🔹 Extract Unique Roles
  //       const uniqueRoles = [
  //         ...new Set(userData.map((u) => u.role?.toLowerCase())),
  //       ];

  //       setRoles(uniqueRoles);
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //     }

  //     setLoading(false);
  //   };

  //   fetchUsers();
  // }, [token]);

  // 🔹 Filter Users by Role
  useEffect(() => {
    if (selectedRole === "all") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (u) => u.role?.toLowerCase() === selectedRole
      );

      setFilteredUsers(filtered);
    }
  }, [selectedRole, users]);

  // 🔹 CSV Export
  const handleExportCSV = () => {
    const headers = [
      "Sr No",
      "First Name",
      "Last Name",
      "Email",
      "Phone",
      "Role",
      "Status",
      "Created At",
    ];

    const rows = filteredUsers.map((u, i) => [
      i + 1,
      u.firstName,
      u.lastName,
      u.email,
      u.phone,
      u.role,
      u.is_approve ? "Approved" : "Pending",
      u.created_at,
    ]);

    const csvContent = [
      [`Role:,${selectedRole === "all" ? "All Users" : selectedRole}`],
      [],
      headers,
      ...rows,
    ]
      .map((e) => e.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");
    link.href = encodeURI(csv);
    link.download = `user_report_${selectedRole}.csv`;
    link.click();
  };

  // 🔹 PDF Export
  const handleExportPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("User Report", 14, 15);

    doc.setFontSize(12);
    doc.text(
      `Role: ${selectedRole === "all" ? "All Users" : selectedRole}`,
      14,
      25
    );

    autoTable(doc, {
      startY: 35,
      head: [
        [
          "Sr No",
          "Name",
          "Email",
          "Phone",
          "Role",
          "Status",
          "Created At",
        ],
      ],
      body: filteredUsers.map((u, i) => [
        i + 1,
        `${u.firstName} ${u.lastName}`,
        u.email,
        u.phone,
        u.role,
        u.is_approve ? "Approved" : "Pending",
        u.created_at,
      ]),
    });

    doc.save(`user_report_${selectedRole}.pdf`);
  };



const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};



  return (
    <Box className="report-container">
      {/* 🔹 TOP BAR */}
      <Box className="top-bar">
        {/* ROLE DROPDOWN */}
        <FormControl className="dropdown">
          <InputLabel>Select Role</InputLabel>

          <Select
            value={selectedRole}
            label="Select Role"
            onChange={(e) => setSelectedRole(e.target.value)}
          >
           {/* ✅ Show ALL only for Admin/Customer */}
{role !== "S" && (
  <MenuItem value="all">All</MenuItem>
)}

            {roles.map((role, index) => (
              <MenuItem key={index} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* EXPORT BUTTONS */}
        <Box className="export-buttons">
          <Button onClick={handleExportCSV} className="btn-csv">
            CSV
          </Button>

          <Button onClick={handleExportPDF} className="btn-pdf">
            PDF
          </Button>
        </Box>
      </Box>

      {/* 🔹 TABLE */}
      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Role</TableCell>
              {/* <TableCell>Status</TableCell> */}
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : filteredUsers.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Data
                </TableCell>
              </TableRow>
            ) : (
              // filteredUsers.map((u, index) => (
              filteredUsers
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((u, index) => (
                <TableRow key={u.id}>
                  {/* <TableCell>{index + 1}</TableCell> */}
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                  <TableCell>
                    {u.firstName} {u.lastName}
                  </TableCell>

                  <TableCell>{u.email}</TableCell>

                  <TableCell>{u.phone}</TableCell>

                  <TableCell>{u.role}</TableCell>

                  {/* <TableCell>
                    <span
                      style={{
                        color: u.is_approve ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {u.is_approve ? "Approved" : "Pending"}
                    </span>
                  </TableCell> */}

                  <TableCell>{u.created_at}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      
      </TableContainer>
        <TablePagination
  rowsPerPageOptions={[10, 20, 35, 50]}
  component="div"
  count={filteredUsers.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
/>
    </Box>
  );
}